<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				{{ $t("title.manage_shift") }}
				<v-spacer></v-spacer>
				<v-select
					:items="outlets"
					v-model="outlet_uuid"
					:label="$t('label.outlet')"
					item-value="uuid"
					item-text="name"
				></v-select>
			</v-card-title>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12>
						<app-datatable
							:title="$t('title.reservation_shifts')"
							:endpoint="endpoint"
							:data="data"
							:headers="headers"
							:groupBy="'day'"
							@onEdit="editItem"
							@onDelete="deleteItem"
							@onView="viewItem"
						>
							<template v-slot:[`item.active`]="{ item }">
								<app-active-button
									:endpoint="
										$route(
											'tenant.activation.reservation_shift',
											{
												tenant: $page.props.tenant.id,
												reservation_shift: item.uuid,
											}
										)
									"
									v-model="item.active"
								></app-active-button>
							</template>
						</app-datatable>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>

		<app-create-fab-button
			@click="
				$inertia.visit(
					$route(
						'tenant.reservation_shifts.create',
						$page.props.tenant.id
					)
				)
			"
			:permission="'create reservation_shifts'"
		></app-create-fab-button>

		<app-tenant-delete-dialog
			ref="deleteDialog"
			:endpoint="'tenant.reservation_shifts.destroy'"
			:uuid="item.uuid"
			:data="{
				tenant: $page.props.tenant.id,
				reservation_shift: item.uuid,
			}"
		></app-tenant-delete-dialog>
	</v-container>
</template>

<script>
export default {
	props: ["data", "outlet", "outlets"],

	data() {
		return {
			outlet_uuid: this.outlet ? this.outlet?.uuid : null,
			item: {},
		};
	},

	computed: {
		endpoint() {
			return this.$route("tenant.reservation_shifts.index", {
				tenant: this.$page.props.tenant.id,
				outlet: this.outlet?.uuid,
			});
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					sortable: false,
					align: "left",
					width: 80,
				},
				{
					text: this.$t("label.day"),
					value: "day",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("Name"),
					value: "name",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("label.time_start"),
					value: "time_start",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("label.time_end"),
					value: "time_end",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("label.time_interval"),
					value: "time_interval",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("label.pax_min"),
					value: "pax_min",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("label.pax_max"),
					value: "pax_max",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("label.pax_total"),
					value: "pax_total",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("Active"),
					value: "active",
					sortable: false,
					width: 80,
				},
			];
		},
	},

	watch: {
		outlet_uuid: {
			async handler() {
				if (this.outlet_uuid) {
					await this.getItems();
				}
			},
			immediate: false,
		},
	},

	methods: {
		async getItems() {
			try {
				this.$inertia.reload({
					only: ["data"],
					data: { outlet_uuid: this.outlet_uuid },
				});
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
		editItem(item) {
			this.$inertia.get(
				this.$route("tenant.reservation_shifts.edit", {
					tenant: this.$page.props.tenant.id,
					outlet: this.outlet?.uuid,
					reservation_shift: item.uuid,
				})
			);
		},
		viewItem(item) {
			this.$inertia.get(
				this.$route("tenant.reservation_shifts.show", {
					tenant: this.$page.props.tenant.id,
					outlet: this.outlet?.uuid,
					reservation_shift: item.uuid,
				})
			);
		},
		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},
	},
};
</script>